// @flow

import React from 'react';
import type { Node } from 'react';

type Props = {
  children: Node,
  className: string,
  styles: Object,
  id: string
};

const WhitePanel = ({ className = '', id = '', children, styles = {} }: Props) => (
  <div className={`${className} white-panel`} style={styles} id={id}>
    {children}
  </div>
);

export default WhitePanel;



// WEBPACK FOOTER //
// ./src/components/UI/WhitePanel.jsx